export default __webpack_public_path__ + "static/media/img2.d180cfb1.png";